import { getMakeAPI, Method } from '@golden/getch';
import { convertUnixToDate } from '@golden/utils';
import { map } from 'rxjs';
const makeAPI = getMakeAPI('v1');
export const EXCHANGE_RATE_API = {
    GET_EXCHANGE_RATE: makeAPI(Method.GET, 'exchange-rate')()
};
export function createExchangeRateService(api) {
    return {
        getExchangeRate() {
            return api.fetch(EXCHANGE_RATE_API.GET_EXCHANGE_RATE).pipe(map((result) => convertUnixToDate(result, 'expired_at')));
        }
    };
}
//# sourceMappingURL=ExchangeRateService.js.map